import { getDatesBetween, isWeekend, toDateKey } from "./staffHolidayDateUtils";

export const calculateLeaveDays = ({
  startDate,
  endDate,
  startDayType = "full",
  endDayType = "full",
  bankHolidays = [],
}) => {
  const bankHolidayMap = new Map(
    bankHolidays.map((holiday) => [holiday.date, holiday]),
  );

  const dates = getDatesBetween(startDate, endDate);

  let totalDays = 0;
  const includedDates = [];
  const excludedDates = [];

  dates.forEach((date, index) => {
    const dateKey = toDateKey(date);
    const bankHoliday = bankHolidayMap.get(dateKey);

    if (isWeekend(date)) {
      excludedDates.push({
        date: dateKey,
        reason: "weekend",
      });
      return;
    }

    if (bankHoliday) {
      excludedDates.push({
        date: dateKey,
        reason: "bank_holiday",
        title: bankHoliday.title,
      });
      return;
    }

    let dayValue = 1;
    let dayPart = "full";

    const isSingleDate = startDate === endDate;
    const isFirstDate = index === 0;
    const isLastDate = index === dates.length - 1;

    if (isSingleDate) {
      if (startDayType !== "full") {
        dayValue = 0.5;
        dayPart = startDayType;
      } else if (endDayType !== "full") {
        dayValue = 0.5;
        dayPart = endDayType;
      }
    } else {
      if (isFirstDate && startDayType !== "full") {
        dayValue = 0.5;
        dayPart = startDayType;
      }

      if (isLastDate && endDayType !== "full") {
        dayValue = 0.5;
        dayPart = endDayType;
      }
    }

    totalDays += dayValue;

    includedDates.push({
      date: dateKey,
      dayValue,
      dayPart,
    });
  });

  return {
    totalDays,
    includedDates,
    excludedDates,
  };
};

export const calculateRemainingLeave = (balance = {}) => {
  const entitlement = Number(balance.entitlement || 0);
  const carriedForward = Number(balance.carriedForward || 0);
  const extraDays = Number(balance.extraDays || 0);
  const borrowedFromNextYear = Number(balance.borrowedFromNextYear || 0);
  const annualLeaveTaken = Number(balance.annualLeaveTaken || 0);
  const annualLeavePending = Number(balance.annualLeavePending || 0);

  return (
    entitlement +
    carriedForward +
    extraDays -
    borrowedFromNextYear -
    annualLeaveTaken -
    annualLeavePending
  );
};

export const getDefaultBalanceForYear = ({
  year,
  entitlement = 20,
  createdBy = "",
}) => {
  return {
    year,
    entitlement,
    carriedForward: 0,
    extraDays: 0,
    borrowedFromNextYear: 0,

    annualLeaveTaken: 0,
    annualLeavePending: 0,
    sickLeaveTaken: 0,
    unpaidLeaveTaken: 0,
    paidLeaveTaken: 0,

    remaining: entitlement,

    notes: "",
    isProRata: false,

    updatedBy: createdBy,
  };
};
